import { FC } from 'react';
import { removeHtmlTagsFromString } from '../../../utils/StringUtils';
import { cn } from '../../../utils/classUtils';

interface ConfigDrivenTitleV2Props {
  title: string;
  textStyle?: string;
}

const ConfigDrivenTitleV2: FC<ConfigDrivenTitleV2Props> = ({
  title,
  textStyle,
}) => {
  return (
    <span
      className={cn(
        'font-inter font-semibold text-2xl text-reskin-primary-navy',
        textStyle,
      )}
    >
      {removeHtmlTagsFromString(title)}
    </span>
  );
};

export default ConfigDrivenTitleV2;
